import { Button, OneColumnStack, Section } from "@arp/react-ndbx";
import { Paper, Typography, Fade } from "@mui/material";
import useTheme from "@mui/material/styles/useTheme";
import React, { useEffect, useState } from "react";

//** Components */
import Page from "../../components/Page";
import ToggleButtonChildrenNotification from "../../components/organisms/ToggleButtonChildrenNotification.jsx";
import YourDetailsHeader from "../../components/pageLevel/YourDetailsHeader.jsx";

//** Context */
import { useWatch } from "react-hook-form";
import { useOutletContext } from "react-router-dom";
import usePreQualification from "../../hooks/usePreQualification";
import usePreQualificationPages from "../../hooks/usePreQualificationPages";

//** Config  */
import {
  contactCenterOpeningScriptFieldNames,
  selectCoverFieldNames,
} from "../../config/pageInfo/pageFieldName";
import {
  additionalSummaryInstruction,
  noAdviceWarning,
  optOutDirectMarketingQuestion,
  pds,
  playDutyAndPrivacyNoticeRecording,
  privacyRecordingQuestion,
} from "../../config/questions/questionComponents.jsx";
import { questionTypes } from "../../config/questions/questionItems.js";
import { PATH_CONTACT_CENTER } from "../../routes/paths";
import { pushEvent, trackifyPageChange } from "@allianz/tracking";
import { Application } from "../../config/const/enums";

//----------------------------------------------------------------

//----------------------------------------------------------------
export default function OpeningScript() {
  const {
    isDirty: [isDirty],
    isValid: [isValid],
    methods: [methods],
    errors: [...errors],
  } = useOutletContext();

  const { state } = usePreQualificationPages();
  const { dataSet } = usePreQualification();
  const { currentPage } = { ...state };
  const { control, setValue } = { ...methods };
  const theme = useTheme();

  // ****************************************************************
  //** Privacy Recording Question */
  const [showPrivacyRecordingQuestion, setPrivacyRecordingQuestion] =
    useState(false);
  const privacyRecordingQuestionWatch = useWatch({
    control,
    name: contactCenterOpeningScriptFieldNames().OPENING_QUESTION,
  });

  useEffect(() => {
    const outputPrivacyRecordingQuestionWatch =
      privacyRecordingQuestionWatch === "no";

    setValue(selectCoverFieldNames("personOne").TERMS_AND_CONDITIONS, true);

    setPrivacyRecordingQuestion(outputPrivacyRecordingQuestionWatch);
  }, [privacyRecordingQuestionWatch]);

  useEffect(() => {
    trackifyPageChange(currentPage?.identifier?.toLowerCase());
    pushEvent("purchasePath", Application.CONTACT_CENTER, true);
  }, []);

  // ****************************************************************

  return (
    <>
      <Page
        mt={8}
        title={currentPage.title}
        identifier={currentPage.identifier}
      >
        <Fade in={true} timeout={500}>
          <div>
        <YourDetailsHeader
          isOnline={false}
          href={PATH_CONTACT_CENTER.retrieveQuote}
        />
        <Section mb={{ xs: 3, sm: 8 }} mt={5}>
          <Paper
            elevation={0}
            md={12}
            sx={{
              backgroundColor: theme.palette.soft.softBeige150,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              maxWidth: { xs: 343, sm: 704, md: 960 },
              pb: { xs: 3, md: 7 },
              pt: { xs: 3, md: 8 },
              pl: { xs: 0, sm: 10, md: 6 },
              pr: { xs: 0, sm: 10, md: 6 },
            }}
          >
            <Section>
                  <Typography variant="h2-bold">
                    Important Information
                  </Typography>
            </Section>
            <Section
              xs={12}
              mb={{ xs: 3, md: 5 }}
              mt={5}
              sx={{ outline: "0px solid red" }}
            >
              <Typography variant="h5-bold">
                Your duty to take reasonable care not to make a
                misrepresentation and Privacy
              </Typography>
            </Section>
            <Section>
              <ToggleButtonChildrenNotification
                dataSetItem={dataSet.privacyRecordingQuestion} // Default value.
                fieldName={
                  contactCenterOpeningScriptFieldNames()
                    .PRIVACY_RECORDING_QUESTION
                }
                items={questionTypes.YES_NO}
                showNotification={false}
                showTooltip={false}
                children={privacyRecordingQuestion}
              />
            </Section>
            <Section>
              <ToggleButtonChildrenNotification
                dataSetItem={dataSet.additionalSummaryQuestion} // Default value.
                fieldName={
                  contactCenterOpeningScriptFieldNames()
                    .ADDITIONAL_SUMMARY_QUESTION
                }
                items={questionTypes.YES_NO}
                showNotification={false}
                showTooltip={false}
                children={playDutyAndPrivacyNoticeRecording}
              />
            </Section>
            {additionalSummaryInstruction}
            {noAdviceWarning}
            {pds}

            <Section>
              <ToggleButtonChildrenNotification
                dataSetItem={dataSet.optOutDirectMarketingQuestion} // Default value.
                fieldName={
                  contactCenterOpeningScriptFieldNames()
                    .OPT_OUT_DIRECT_MARKETING_QUESTION
                }
                items={questionTypes.YES_NO}
                showNotification={false}
                showTooltip={false}
                children={optOutDirectMarketingQuestion}
              />
            </Section>
          </Paper>
        </Section>
        <OneColumnStack
          flexShrink={1}
          sx={{
            width: { xs: 312, sm: 344, md: 312 },
          }}
        >
          <Button
            id="agree-proceed"
            ariaLabel="agree and proceed"
            variant="contained"
            color="primary"
            size="medium"
            type="submit"
            disabled={!isDirty || !isValid}
          >
            I Agree and Continue
          </Button>
        </OneColumnStack>
          </div>
        </Fade>
      </Page>
    </>
  );
}
